<template>
	<div class="item-container">
		<div class="messages">
			<div
				v-for="(message, j) in messages"
				:key="'forced-message--' + j"
				:style="{'animation-delay': (j + 's')}"
				class="message"
			>
				<span v-html="message"/>
			</div>
		</div>
		<div
			class="item-edit"
			:style="{'animation-delay': messages.length + 's'}"
		>
			<template v-if="typeIsPreExperience">
				<b-row align-v="center" class="mb-4">
					<b-col md="4">
						<Avatar :avatar="avatarBreak" fluid />
					</b-col>
				</b-row>
			</template>
		</div>
	</div>
</template>

<script>
import Avatar, {BREAK} from "@/vue/common/image/Avatar.vue";

export const TYPE__PRE_EXPERIENCE = 'pre-experience';

const MESSAGES = {
	[TYPE__PRE_EXPERIENCE]: [
		'Gratuliere!',
		'Dein Profil ist nun <b>anonymisiert veröffentlicht</b> und kann von Arbeitgebern gefunden werden. Natürlich bleiben dabei deine persönlichen Daten (wie Name, Geburtsdatum, Wohnort, E-Mail Adresse usw.) geheim und werden nur dann für einen Arbeitgeber sichtbar, wenn du ihm die Daten <b>freigibst</b>.',
		'Für das <b>passende Matching</b> benötigen wir noch ein paar Informationen.',
	],
};

export default {
	components: {Avatar},

	props: {
		type: {
			type: String,
			required: true,
		}
	},

	computed: {
		avatarBreak ()
		{
			return BREAK;
		},
		messages ()
		{
			return MESSAGES[this.type];
		},
		typeIsPreExperience ()
		{
			return this.type === TYPE__PRE_EXPERIENCE;
		}
	}
}
</script>
